/*export const GLOBAL_SETTINGS = ["associatedClient"];

export const NONUSER_SETTINGS = [
  "showBilling",
  "ganttEnabled",
  "approvedRequirementStageDropdown",
  "requirementVersionsCategoryDropdown",
  "proposedRequirementStageDropdown",
  "requirementCategoryDropdown",
  "issueCategoryDropdown",
  "openStageDropdown",
  "assignedStageDropdown",
  "pendingStageDropdown",
  "resolvedStageDropdown",
  "decisionNeededStageDropdown",
  "decisionMadeStageDropdown",
  "riskCategoryDropdown",
  "actionCategoryDropdown",
  "assumptionCategoryDropdown",
  "decisionCategoryDropdown",
  "etcCalcOption",
];*/

export const USER_OADA_SETTINGS = [
  "changeLogCheckboxSettingsTasks",
  "changeLogCheckboxSettingsReqs",
  "changeLogCheckboxSettingsIssues",
  "startingDashboardScreen",
  "lastProjectRefresh",
  "associatedClient",
];

export const INSTANCE_OADA_SETTINGS = [
  "riskCategoryDropdown_options",
  "actionCategoryDropdown_options",
  "assumptionCategoryDropdown_options",
  "issueCategoryDropdown_options",
  "decisionCategoryDropdown_options",
  "requirementCategoryDropdown_options",
  "storageOption",
  "openStageDropdown_options",
  "assignedStageDropdown_options",
  "pendingStageDropdown_options",
  "resolvedStageDropdown_options",
  "decisionNeededStageDropdown_options",
  "decisionMadeStageDropdown_options",
  "requirementVersionsCategoryDropdown_options",
  "approvedRequirementStageDropdown_options",
  "proposedRequirementStageDropdown_options",
  "highSeverityDropdown_options",
  "mediumSeverityDropdown_options",
  "lowSeverityDropdown_options",
  "showWhiteboardSetting",
];

export const PROJECT_OADA_SETTINGS = [
  "thresholds",
  "showFinancialsExternal",
  "ganttDateSource",
  "ganttDateEditing",
  "ganttSource",
  "etcCalcOption",
  "reqCategories",
];

export const STORAGE_OPTIONS = [
  "SuiteProjects Pro Workspace",
  "Addolution Storage",
];
